<template>
  <div class="pane-header px-4 pt-4">
    <div>
      <p class="text--x-large font-weight-light mb-0">
        {{ $t(`${TRANSLATION_KEY_PREFIX}.mainTitle`, { userName: userName || $t('common.user') }) }}
      </p>
      <p
        class="font-weight-bold text--medium"
        data-locator="ai-assistant-header-subtitle"
      >
        {{ subtitle }}
      </p>
    </div>
    <app-button
      data-locator="ai-assistant-close-button"
      class="pane-close-button"
      type="icon"
      @click="onClosePane"
    >
      <app-material-icon name="close" />
    </app-button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'vuex'

import { AIAssistantQuestionTypes } from '@/types/ai-assistant';
const TRANSLATION_KEY_PREFIX = 'common.ai-assistant.AIAssistantPane'

export default defineComponent({
  name: 'AIAssistantPaneHeader',
  props: {
    userName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      TRANSLATION_KEY_PREFIX,
    }
  },
  emits: ['close-pane'],
  computed: {
    ...mapState('aiAssistant', ['questionType']),
    subtitle () {
      if (!this.questionType) {
        return this.$t(`${TRANSLATION_KEY_PREFIX}.mainSubtitle`)
      }
      if (this.questionType === AIAssistantQuestionTypes.ASK_DOC) {
        return this.$t(`${TRANSLATION_KEY_PREFIX}.askDoc.subtitle`)
      }
      return this.$t(`${TRANSLATION_KEY_PREFIX}.ask.subtitle`)
    },
  },
  methods: {
    onClosePane() {
      this.$emit('close-pane')
    },
  },
})
</script>
